import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { FileParser, FileParseResult } from './file-parser.interface';

@Injectable({
  providedIn: 'root',
})
export class XlsxFileParserService implements FileParser {
  private readonly supportedExtensions = ['xls', 'xlsx', 'xlsm', 'xlsb'];

  canParse(file: File): boolean {
    const extension = this.getFileExtension(file.name);
    return this.supportedExtensions.includes(extension);
  }

  async parse(file: File, preview?: number): Promise<FileParseResult> {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });

    // Get the first sheet
    const firstSheetName = workbook.SheetNames[0];
    if (!firstSheetName) {
      return { data: [], errors: [] };
    }

    const worksheet = workbook.Sheets[firstSheetName];
    if (!worksheet) {
      return { data: [], errors: [] };
    }

    const jsonData: string[][] = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      raw: false,
      defval: '',
    });

    // Filter out completely empty rows
    const filteredData = jsonData.filter((row) => row.some((cell) => cell !== ''));

    // Apply preview limit if specified
    const data = preview ? filteredData.slice(0, preview) : filteredData;

    return {
      data,
      errors: [],
    };
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }
}
